//@flow
import React from "react";
import { NumberField } from "@quantum/ui";

import "./selecao-tolerancia.css";

type Props = {
  min?: number,
  max?: number,
  toleranciaSelecionada: number,
  onChange: any => any,
};

function SelecaoToleranciaInteiroNaoNegativo({
  min = 0,
  max = 1000,
  toleranciaSelecionada,
  onChange,
  ...props
}: Props) {
  return (
    <div className="SelecaoTolerancia">
      <NumberField
        decimalScale={0}
        max={max}
        min={Math.max(min, 0)}
        value={toleranciaSelecionada}
        onChangeValue={onChange}
        {...props}
      />
    </div>
  );
}

export default SelecaoToleranciaInteiroNaoNegativo;
